import { notifications } from '@mantine/notifications';
import { OrderingInitialState, RemoveOrDecrementItemAction } from '@reducers/ordering/types';
import { current } from '@reduxjs/toolkit';
import messages from '@shared/constants/messages';

// This function is used inside the removeOrDecrementItemFromOrder function
const decrementOrRemoveItem = (state: OrderingInitialState, menuItemId: string): OrderingInitialState => {
  const findIndex = current(state.orderState.menus || []).findIndex((x) => x.menuItemId === menuItemId);
  const find = current(state?.orderState.menus || [])[findIndex];
  if (find?.count === 1) {
    const orderOrderItems = state?.orderState.menus
      ?.filter((x) => x.tempId !== find.tempId)
      .reduce((acc, cur) => acc + (cur?.count || 0), 0);

    if (orderOrderItems === 0) {
      notifications.show({
        message: messages.NOT_ALLOW_REMOVE_ALL_ITEMS,
        color: 'red',
      });
      return { ...state };
    }
    return {
      ...state,
      orderState: {
        ...state.orderState,
        menus: current(state?.orderState.menus || []).filter((_, i) => i !== findIndex),
      },
    };
  }
  return {
    ...state,
    orderState: {
      ...state.orderState,
      menus: current(state?.orderState.menus || []).map((item, index) => {
        if (index === findIndex) {
          return {
            ...item,
            count: (item?.count || 0) - 1,
            orderItemToppings: item?.orderItemToppings?.map((x) => ({
              ...x,
              count: (item.count || 0) - 1,
            })),
          };
        }
        return item;
      }),
    },
  };
};

export const removeOrDecrementItem = (
  state: OrderingInitialState,
  action: RemoveOrDecrementItemAction
): OrderingInitialState => {
  const menuItemId = action.payload;

  if (state.orderState.isEdited) return decrementOrRemoveItem(state, menuItemId);

  const findIndex = current(state.orderState.menus).findIndex((x) => x.menuItemId === menuItemId);

  const find = current(state.orderState.menus)[findIndex];

  if (find?.count === 1) {
    return {
      ...state,
      orderState: {
        ...state.orderState,
        menus: current(state.orderState.menus).filter((_, i) => i !== findIndex),
      },
    };
  }

  return {
    ...state,
    orderState: {
      ...state.orderState,
      menus: current(state.orderState.menus).map((item, index) => {
        if (index === findIndex) {
          return {
            ...item,
            count: (item?.count || 0) - 1,
            orderItemToppings: item?.orderItemToppings?.map((x) => ({
              ...x,
              count: (item.count || 0) - 1,
            })),
          };
        }
        return item;
      }),
    },
  };
};
